module.exports = ".university-label {\n  font-weight: 500;\n  width: 50%;\n  padding-top: 5px; }\n\n.card {\n  margin-top: 5px; }\n\n.app-table td {\n  border: 1px solid rgba(0, 0, 0, 0.03);\n  vertical-align: top; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/college-info/college-info.component.scss
// module id = ./src/app/modules/common-main/components/college-info/college-info.component.scss
// module chunks = main